import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCustomersTransactionLogsQuery } from '../store/services/customers';

const ProblemOutgoingTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    customersProblemTransactions: {
      outgoing: { logs },
    },
    customersDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const [getOutgoingLogs, { isLoading }] =
    useLazyGetCustomersTransactionLogsQuery();

  const getOutgoingLogsAction = useCallback(() => {
    getOutgoingLogs(transactionId as string);
  }, [transactionId]);

  useEffect(() => {
    if (!logs && transactionId) {
      getOutgoingLogsAction();
    }
  }, [getOutgoingLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoading}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_OUTGOING_LIST,
      )}
    />
  );
};

export default ProblemOutgoingTransactionLogContentHOC;
